import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MapSummaryLocationComponent } from '~/map/page/summary/mapSummaryLocation.component';
import { demographicsListGlobalFetchDataRequest } from '~/store/demographics/demographicsListGlobal/demographicsListGlobal.actionCreators';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';
import { ExportReportActiveType } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const MapSummaryContainer = () => {
  const exportReportState = useToolsStateExportReportSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!exportReportState.isActive) {
      return;
    }
    dispatch(demographicsListGlobalFetchDataRequest());
  }, [dispatch, exportReportState.isActive]);

  if (!exportReportState.isActive) {
    return null;
  }

  if (exportReportState.params.type === ExportReportActiveType.Location) {
    return <MapSummaryLocationComponent params={exportReportState.params} />;
  }

  return null;
};
